import { useQuery } from '@tanstack/react-query';
import { fetchTestCasesNotAutomated } from '../../../../../modules/dashboard';
import Widget from './Widget';
const TestCasesNotAutomated = ({ projectId, isAdmin }) => {
  const { data, isLoading } = useQuery({
    queryKey: [`testCasesAutomationCoverage`, projectId],
    queryFn: () => fetchTestCasesNotAutomated(projectId, isAdmin),
    enabled: !!projectId && isAdmin !== undefined,
  });

  
  return (
    <div>
      <Widget
        title={isAdmin ? "Automation Coverage": "TCs Automated By You"}
        percentage={isAdmin ? true : false}
        body={data ? parseInt(data?.data?.percentage_automated) : 0}
        loading={isLoading}
      />
    </div>
  );
};

export default TestCasesNotAutomated;
